import React, { useEffect, useRef } from 'react'

import { Select } from 'antd'

import fullstory from '../../../utils/constants/fullstory'

const InputWithArrayValue = React.forwardRef((props, ref) => {
  const { setFields } = /** @type {any} */ (props)
  const containerRef = useRef(null)

  const handleChange = values =>
    setFields?.({
      email: {
        value: values,
      },
    })

  useEffect(() => {
    const patchCloseButtons = () => {
      if (!containerRef.current) return
      containerRef.current.querySelectorAll('.ant-select-selection__choice').forEach(tag => {
        const title = tag.getAttribute('title')
        const closeBtn = tag.querySelector('.ant-select-selection__choice__remove')
        if (closeBtn && title) {
          closeBtn.setAttribute('role', 'button')
          closeBtn.setAttribute('aria-label', `Remove ${title}`)
          const icon = closeBtn.querySelector('.anticon')
          if (icon) icon.setAttribute('aria-hidden', 'true')
        }
      })
    }

    patchCloseButtons()
    const observer = new MutationObserver(patchCloseButtons)
    if (containerRef.current) {
      observer.observe(containerRef.current, { childList: true, subtree: true })
    }
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={containerRef}>
      <Select
        ref={ref}
        {...props}
        mode="tags"
        dropdownStyle={{ display: 'none' }}
        onChange={handleChange}
        className={fullstory.classNames.textInput}
      />
    </div>
  )
})

export default InputWithArrayValue
